const stripHtml = function(content: string) {
  const domParser = new DOMParser()
  const strippedContent = domParser.parseFromString(content, 'text/html').body.textContent
  return strippedContent
}

export default {
  stripHtml: stripHtml
}
